import React from "react";
import AdminPanelDom from "../domains/adminPanel/adminPanelDom";
import Configura from "./Configura";


class SuperAdminConfigura extends React.Component {
  render() {
    return (
      <AdminPanelDom
     component={()=>
        <Configura />
        }
        {...this.props}
      />
    );
  }
}

export default SuperAdminConfigura;